export default __webpack_public_path__ + "static/media/img_tandberg_cseries-colorBkg.550d7ee2.png";